<template>
  <div id="app">
    <v-app>
    <router-view name="login" />
    <router-view name="header" />
    <router-view />
    <router-view name="addpatient" />
    <router-view name="vitalsPost" />
    <router-view name="masterPatientDataStatic" />
    <router-view name="billingModule" />
    <router-view name="allBills" />
    <router-view name="prescription" />
    <router-view name="profileAdd" />
    <router-view name="profileEdit" />
    <router-view name="forms" />
    <router-view name="allPatients" />
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'app'
};
</script>

<style>
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
.application--wrap {
  min-height: auto;
}
#app {
  font-family: 'Assistant', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.img-fluid {
  max-width: 100%;
}
/* primary: '#018FFF',
    secondary: '#383B3F',
    accent: '#74CB74',
    error: '#D85959' */
.primary {
  background-color: #018fff;
}
.accent {
  color: #fff;
  background-color: #74cb74;
}
.secondary {
  background-color: #383b3f;
}
.error {
  background-color: #d85959;
}
.list__tile--link {
  height: auto;
}
.btn {
  font-weight: 600;
}
.btn.btn--disabled {
  background: gray;
}
.btn--round,
.btn--round:after {
  border-radius: 0.2rem;
}
.zen .el-input-group__append,
.zen .el-input-group__prepend {
  padding: 0px;
  border: 0px;
}
.zen .el-input-group--prepend .el-input__inner,
.el-input-group__append {
  border-radius: 0px;
}
.list__tile__action {
  display: contents;
}
#mySelect .container.grid-list-md {
  padding: 8px 8px 8px 0rem;
}
.AutoWrapper {
  padding-right: 1rem;
}
.AutoWrapper .dropdown-menu {
  max-height: 290px;
}
.AutoWrapper .dropdown-content .dropdown-item:nth-child(1) {
  padding-top: 0px;
  padding-bottom: 8px;
}
.AutoWrapper .dropdown-content .dropdown-item:nth-child(2) {
  border-top: 0.5px solid #e0e0e0;
  padding-top: 1rem;
}
.AutoWrapper .control .input {
  border-color: #dcdfe6;
  box-shadow: none;
}
.theme--light
  .expansion-panel
  .expansion-panel__container
  .expansion-panel__header
  .icon {
  color: #fff !important;
}
.item #mySelect {
  padding: 0.4rem 0rem;
}
.expansion-panel__body .list {
  padding: 0.5rem 0rem 0rem 0rem;
}
#app .dialog {
  overflow: initial;
}
.sidebar li.active a {
  color: white;
}
.sidebar li:nth-child(2) a {
  color: #56ccf2;
}
.overlay.overlay--active {
  z-index: 2001 !important;
}
.dialog__content.dialog__content__active {
  z-index: 2002 !important;
}
.el-picker-panel.el-date-picker.el-popper {
  z-index: 2003 !important;
}
.d-none {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue